<template>
  <SysDialog
    v-model="MODAL_ATIVO_COMPUTED"
    largura="500"
    content-class="bra-8"
    titulo="Alteração em Massa"
    ocultar-acoes
  >
    <v-form ref="form" v-model="formValido" lazy-validation>
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            v-model="form.pertence_ao_mix"
            :items="opcoes_mix"
            :rules="[rules.required]"
            label="Pertence ao Mix? *"
            hide-details="auto"
            color="#013254"
            append-icon="$CaretDown"
            class="custom-select"
            dense
            outlined
            item-text="label"
            item-value="value"
          />

        </v-col>

        <v-col cols="12" sm="6">
          <v-select
            v-model="form.movimentacao"
            :items="opcoes_movimentacao"
            :rules="[rules.required]"
            label="Movimentação"
            hide-details="auto"
            append-icon="$CaretDown"
            class="custom-select"
            dense
            outlined
            item-text="label"
            item-value="value"
          />
        </v-col>

        <v-col cols="12">
          <v-divider class="mt-n4 mb-3" />

          <div style="color: #19191C;" class="d-flex justify-space-between font-14 mb-2 font-weight-medium">
            <span>Justificativa para a Alteração <span class="font-14 text-red">*</span></span>

            <v-icon color="#19191C" @click="dialog_historico = true">
              $ClockCounterClockwise
            </v-icon>
          </div>

          <v-textarea
            v-model="form.justificativa"
            :rules="[rules.required]"
            rows="4"
            auto-grow
            outlined
            hide-details="auto"
            placeholder="Descreva o motivo da alteração…"
          />
        </v-col>
      </v-row>

      <div class="d-flex justify-center mt-3 mb-5 px-1">
        <v-btn
          color="#013254"
          class="vbtn-class bra-8 w-50-porcento"
          height="35"
          outlined
          @click="voltar"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="#013254"
          class="white--text text-none bra-8 w-50-porcento"
          height="35"
          :loading="loading"
          @click="salvar"
        >
          Aplicar
        </v-btn>
      </div>
    </v-form>

    <SysDialog
      v-model="dialog_historico"
      titulo="Histório de Justificativas"
      content-class="bra-8"
      ocultar-acoes
      :largura="450"
    >
      <template #titulo>
        <div class="d-flex justify-space-between w-full">
          <div class="d-flex flex-column w-full">
            <span class="font-18">Histórico de Alterações</span>
            <p class="font-13 font-weight-regular text-gray-300 mt-n3">Visualize todas as alterações realizadas no
              sistema</p>
          </div>

          <v-btn icon @click="dialog_historico = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>

      <div class="text-center" v-if="historico_alteracao.length <= 0">
        <span>Nenhuma justificativa registrada até o momento.</span>
      </div>

      <div v-for="(h, index) in historico_alteracao" :key="h.id">
        <div class="d-flex flex-column">
          <span class="text-gray-300 font-13">{{
              moment(h.data_justificativa, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm')
            }} • {{ h.nome_usuario }}</span>
          <span class="mt-n1 font-14 text-black">{{ h.justificativa }}</span>
        </div>

        <v-divider class="my-4" />
      </div>
    </SysDialog>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";
import moment from "moment/moment";

export default {
  name: "DialogAlterarEmMassa",
  components: { SysDialog },
  props: {
    value: { type: Boolean, required: true },
    selecionados: { type: Array, required: false },
    inicial: {
      type: Object,
      default: () => ({
        pertence_ao_mix: "S",
        movimentacao: "PROPRIA",
        justificativa: "",
      }),
    },
  },
  data() {
    return {
      loading: false,
      formValido: false,
      form: {
        pertence_ao_mix: this.inicial.pertence_ao_mix,
        movimentacao: this.inicial.movimentacao,
        justificativa: this.inicial.justificativa,
      },
      opcoes_mix: [
        { label: "Sim", value: 'S' },
        { label: "Não", value: 'N' }
      ],
      opcoes_movimentacao: [
        { label: "Própria", value: 'PROPRIA' },
        { label: "Mista", value: 'MISTA' },
        { label: "Retira", value: 'RETIRA' }
      ],
      historico_alteracao: [],
      rules: {
        required: (v) => !!(v && String(v).trim()) || "Campo obrigatório",
      },
      dialog_historico: false
    };
  },
  mounted() {
    this.buscarHistoricoJustificativas();
  },
  computed: {
    moment() {
      return moment
    },
    MODAL_ATIVO_COMPUTED: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    voltar() {
      this.MODAL_ATIVO_COMPUTED = false;
    },
    async salvar() {
      const ok = await this.$refs.form.validate();
      if (!ok) return;

      const produtos = this.selecionados.map(s => ({
        idfilial: s.filial,
        idproduto: s.idproduto
      }));

      const body = {
        produtos,
        movimentacao: this.form.movimentacao,
        pertence_ao_mix: this.form.pertence_ao_mix,
        justificativa: this.form.justificativa
      }

      api.post('mix-produtos-filial/alterar-em-massa', body)
      .then(() => {
        this.$emit("upload:concluido");
        this.buscarHistoricoJustificativas();
      }).catch((error) => {
        alert(error);
      });

      this.MODAL_ATIVO_COMPUTED = false;
    },
    buscarHistoricoJustificativas() {
      api.get('mix-produtos-filial/buscar-justificativas')
      .then((response) => {
        this.historico_alteracao = response.data.justificativas;
      }).catch((error) => {
        alert(error);
      });
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetValidation();
          this.form = { ...this.inicial };
        });
      }
    },
  },
};
</script>

<style scoped>
.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 10px 25px 10px 20px;
  margin-top: 1px;
  margin-right: 15px;
  font-weight: 500;
}
</style>
